import { render, staticRenderFns } from "./PartnersIntake.vue?vue&type=template&id=2a584889&scoped=true"
import script from "./PartnersIntake.vue?vue&type=script&lang=js"
export * from "./PartnersIntake.vue?vue&type=script&lang=js"
import style0 from "./PartnersIntake.vue?vue&type=style&index=0&id=2a584889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a584889",
  null
  
)

export default component.exports